module.exports = __webpack_public_path__ + "static/media/email-icon.97eb7aa3.svg";